(function(){
  const root=document.documentElement;
  const RATE=1.95583;
  const money=(cents)=>{
    cents=Number(cents||0);
    const eur=(cents/100).toLocaleString('bg-BG',{style:'currency',currency:'EUR'}).replace('EUR','€');
    const bgn=((cents/100)*RATE).toLocaleString('bg-BG',{minimumFractionDigits:2,maximumFractionDigits:2})+' лв';
    return `<span class="kz-dual-price" data-kz-dual-price><span class="kz-price-eur">${eur}</span><span class="kz-price-sep">/</span><span class="kz-price-bgn">${bgn}</span></span>`;
  };
  const plainMoney=(cents)=>{
    cents=Number(cents||0);
    const eur=(cents/100).toLocaleString('bg-BG',{style:'currency',currency:'EUR'}).replace('EUR','€');
    const bgn=((cents/100)*RATE).toLocaleString('bg-BG',{minimumFractionDigits:2,maximumFractionDigits:2})+' лв';
    return eur+' / '+bgn;
  };
  const drawer=()=>document.querySelector('[data-kz-drawer]');
  function open(){
    const d=drawer();
    if(!d) return;
    root.classList.remove('kz-menu-open');
    document.querySelectorAll('[data-kz-menu-toggle]').forEach(el=>el.setAttribute('aria-expanded','false'));
    document.querySelectorAll('[data-kz-mobile-menu]').forEach(el=>el.setAttribute('aria-hidden','true'));
    window.requestAnimationFrame(()=>root.classList.add('kz-cart-open'));
    refresh();
  }
  function close(){root.classList.remove('kz-cart-open');}
  async function cart(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});return r.json();}
  async function add(id,qty=1,openAfter=true){if(!id){return;}await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(id),quantity:qty})}); if(openAfter) open(); else refresh();}
  async function addBundle(ids){ids=(ids||'').split(',').map(x=>x.trim()).filter(Boolean); if(!ids.length)return; await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:ids.map(id=>({id:Number(id),quantity:1}))})}); open();}
  async function change(key,qty){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});refresh();}
  async function refresh(){
    const d=drawer(); if(!d) return;
    const c=await cart();
    document.querySelectorAll('[data-kz-header-count]').forEach(el=>el.textContent=c.item_count);
    const items=d.querySelector('[data-kz-cart-items]');
    const count=d.querySelector('[data-kz-cart-count-text]');
    const sub=d.querySelector('[data-kz-subtotal]');
    const free=d.querySelector('[data-kz-free-text]');
    const bar=d.querySelector('[data-kz-free-bar]');
    if(count) count.textContent=c.item_count+' продукта';
    if(sub) sub.innerHTML=money(c.total_price);
    const threshold=Math.max(0,Number(d.dataset.kzFreeThreshold||0));
    const freePrefix=d.dataset.kzFreePrefix||'Добави още';
    const freeSuffix=d.dataset.kzFreeSuffix||'за безплатна доставка';
    const freeSuccess=d.dataset.kzFreeSuccess||'Имаш безплатна доставка';
    const left=Math.max(0,threshold-c.total_price);
    if(free){
      free.innerHTML=threshold>0 && left>0
        ? freePrefix+' '+money(left)+' '+freeSuffix
        : freeSuccess;
    }
    if(bar){
      bar.style.width=threshold>0
        ? Math.min(100,(c.total_price/threshold)*100)+'%'
        : '100%';
    }
    if(!items)return;
    if(!c.items.length){items.innerHTML='<p class="kz-empty">Количката е празна.</p>';return;}
    items.innerHTML=c.items.map(it=>`<div class="kz-cart-line"><img src="${it.image||''}" alt=""><div><div class="kz-line-title">${it.product_title}</div><div class="kz-line-variant">${it.variant_title||''}</div><div class="kz-line-actions"><button data-kz-change="${it.key}" data-qty="${it.quantity-1}">−</button><span>${it.quantity}</span><button data-kz-change="${it.key}" data-qty="${it.quantity+1}">+</button><button class="kz-remove" data-kz-change="${it.key}" data-qty="0">Премахни</button></div></div><div class="kz-line-price">${money(it.final_line_price)}</div></div>`).join('');
  }
  document.addEventListener('click',function(e){
    const openBtn=e.target.closest('[data-kz-cart-open], .icon-btn.cart');
    if(openBtn){e.preventDefault();open();return;}
    if(e.target.closest('[data-kz-cart-close]')){e.preventDefault();close();return;}

    const checkout=e.target.closest('[data-kz-checkout], .kz-checkout');
    if(checkout){
      e.preventDefault();
      window.location.href='/checkout';
      return;
    }
    const addCurrent=e.target.closest('[data-kz-add-current]');
    if(addCurrent){e.preventDefault();add(window.KZ_CURRENT_VARIANT_ID,Number(document.querySelector('#qty')?.value||1));return;}
    const buy=e.target.closest('[data-kz-buy-now]');
    if(buy){
      e.preventDefault();
      const id=window.KZ_CURRENT_VARIANT_ID;
      const qty=Number(document.querySelector('#qty')?.value||1);
      if(id){ location.href='/cart/'+Number(id)+':'+qty+'?checkout'; }
      return;
    }
    const addVariant=e.target.closest('[data-kz-add-variant]');
    if(addVariant){e.preventDefault();add(addVariant.getAttribute('data-kz-add-variant'));return;}
    const addBundleBtn=e.target.closest('[data-kz-add-bundle]');
    if(addBundleBtn){e.preventDefault();addBundle(addBundleBtn.getAttribute('data-kz-add-bundle'));return;}
    const changeBtn=e.target.closest('[data-kz-change]');
    if(changeBtn){e.preventDefault();change(changeBtn.dataset.kzChange,Number(changeBtn.dataset.qty));return;}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && root.classList.contains('kz-cart-open')) close();
  });
  document.addEventListener('DOMContentLoaded',refresh);
})();
